module.exports = __webpack_public_path__ + "img/amenities.jpg";